import styled from 'styled-components';
import { ReactComponent as RawMoveSVG } from '../../../../assets/icons/move_icon.svg';

export const IconMove = styled(RawMoveSVG)``;
